<template>
  <div class="dejhgl-wrap">
    <div class="dejhgl-main" v-show="!showPlanInfo">
      <div class="search-box box">
        <time-search ref="timeSearch" :control="{data:timeType}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick"></time-search>
        <div class="others-btn">
          <el-button type="primary" size="small" @click="add">添加计划</el-button>
        </div>
      </div>
      <div class="table-main">
        <div class="table-box">
          <nk-table id="table" height="100%" :data="tableData" :noDataTitle="'暂无数据'" :columns="columns" :showPage="true" :stripe="false">
            <el-table-column label="计划时间粒度" slot="timeGranularity" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.timeGranularity == "1" ? "月" : "年"}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="seePlan(scope.row)">查看计划详情</el-button>
                <el-button type="text" size="small" @click="removePlan(scope.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </nk-table>
        </div>
      </div>
    </div>
    <div class="dejhgl-main" v-if="showPlanInfo">
      <dejhglInfo :dialogVisible.sync="dialogVisible" :timeGranularityValue="timeGranularityValue" :showPlanInfo.sync="showPlanInfo" :planId="planId" :planName.sync="planName" :planTime.sync="planTime"></dejhglInfo>
    </div>
  </div>
</template>

<script>
import TimeSearch from "@/components/common/TimeSearch.vue";
import NkTable from "@/components/common/NkTable";
import dejhglInfo from "./components/dejhglInfo";
export default {
  name: "Dejhgl",
  components: {
    TimeSearch, NkTable, dejhglInfo
  },
  data () {
    return {
      showPlanInfo: false,//是否显示计划详情
      timeType: [{//时间类型
        type: "timeInterval", label: "时段"
      }],
      timeElem: {},//时间参数信息
      tableData: [],//表格数据
      columns: [{
        prop: "name",
        label: "能源计划名称"
      }, {
        prop: "startTime",
        label: "计划开始时间"
      }, {
        prop: "timeGranularity",
        label: "计划时间粒度",
        slot: "timeGranularity"
      }],//表格列
      dialogVisible: false,//是否显示计划列表
      timeGranularityValue: "1",//时间粒度
      planName: "",//计划名称
      planId: "",//计划ID
      planTime: "",//每一行计划时间
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getData();//获取请求的数据
    });
  },
  methods: {
    timeControlChange (params) {//时间类型变化时
      this.timeElem = Object.assign({}, params);
    },
    TimeControlClick (params) {//点击查询时
      this.timeControlChange(params);
      this.getData();
    },
    async getData () {//根据参数请求数据
      let result = await this.$api.energyPlan.getEnergyPlan(0, this.timeElem.startTime, this.timeElem.endTime);
      if (!result.success) {
        this.$message.error(result.errorStr);
        return;
      }
      this.tableData = Object.assign([], result.data);
    },
    add () {//点击添加计划
      this.planId = "";//新增时清空计划ID
      this.planTime = "";//新增时清空计划时间
      this.planName = "";//新增清空计划名称
      this.timeGranularityValue = "1";//恢复时间粒度的默认值
      this.showPlanInfo = true;//显示计划操作
    },
    seePlan (row) {//点击查看计划详情
      this.planId = row.id;
      this.planName = row.name;
      this.planTime = new Date(row.startTime);
      this.timeGranularityValue = row.timeGranularity + "";
      this.showPlanInfo = true;//显示计划操作
    },
    removePlan (row, index) {
      this.$confirm('是否删除当前计划', '计划删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {//确认删除
        let removeResult = await this.$api.energyPlan.deleteEnergyPlan(row.id);
        if (!removeResult.success) {
          this.$message.error(removeResult.errorStr);
          return;
        }
        this.tableData.splice(index, 1);
        this.$message.success(removeResult.errorStr);
      });
    }
  },
  watch: {
    showPlanInfo (newVal, oldVal) {
      if (!newVal) {//关闭计划详情后重新渲染表格数据
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dejhgl-wrap {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  .dejhgl-main {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-flow: column;
    .search-box {
      display: flex;
      align-items: center;
      height: 36px;
      .fh {
        .fh-label {
          margin: 0 5px;
        }
        .option {
          width: 100px;
        }
      }
      .time-warp {
        width: auto;
        height: auto;
      }
      .others-btn {
        flex: 1;
        text-align: left;
      }
    }
    .table-main {
      flex: 1;
      width: 100%;
      padding: 5px;
      box-sizing: border-box;
      .table-box {
        width: 100%;
        height: 100%;
        ::v-deep .el-table--border {
          border-bottom: 1px solid #ebeef5;
        }
        ::v-deep .table-warp .el-table td {
          border-bottom: 1px solid #ebeef5;
        }
      }
    }
  }
}
</style>